/* imods single-destination chooser (UX round 2, owner 2026-10-02). On a part whose model + component has several products, every
   choice is a link to that product's own page (sections/imods-product.liquid). The links keep the fix method: when the visitor
   picks You Fix It or We Fix It (the buy box's service cards, or the chooser view's own two cards), each choice's link and price
   follow it (part-only or installed variant). Links work without this script; it only keeps them in step. */
(function () {
  'use strict';
  function installed(root) {
    var c = root.querySelector('input[name="imods-choose-svc"]:checked');
    if (c) return c.value === 'install';
    var fs = root.querySelector('fieldset[data-opt="service"]');
    var r = fs && fs.querySelector('input[data-optval]:checked');
    if (!r) return null;
    var v = r.value || '';
    return (/^yes/i.test(v) && /install/i.test(v)) || /^professional installation/i.test(v);
  }
  function pick(a, inst, kind) {
    var p = a.getAttribute('data-' + kind + '-part'), i = a.getAttribute('data-' + kind + '-inst');
    return inst ? (i || p) : (p || i);
  }
  function apply(root) {
    var inst = installed(root);
    if (inst == null) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sib-opt]'), function (a) {
      var h = pick(a, inst, 'href');
      if (h) a.setAttribute('href', h);
      var pe = a.querySelector('[data-sib-price]');
      if (pe && !a.hasAttribute('data-soldout')) { var t = pick(a, inst, 'price'); if (t) pe.textContent = t; }
    });
    var cp = root.querySelector('[data-choose-price]');
    if (cp) { var t2 = cp.getAttribute(inst ? 'data-inst' : 'data-part') || cp.getAttribute(inst ? 'data-part' : 'data-inst'); if (t2) cp.textContent = t2; }
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-imods-sib-root]'), apply); }
  // UX round 3: the general page of an iPod + part (/collections/<collection>/<iPod>) is opened by the menus and help cards with
  // ?fix=installed (We fix it) or nothing (You fix it): pick that fix method once, before the links are set
  try {
    var fx = new URLSearchParams(location.search).get('fix');
    if (fx === 'installed' || fx === 'part') {
      Array.prototype.forEach.call(document.querySelectorAll('[data-imods-sib-root] input[name="imods-choose-svc"]'), function (r) { r.checked = r.value === (fx === 'installed' ? 'install' : 'part'); });
    }
  } catch (e) {}
  document.addEventListener('change', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-imods-sib-root]');
    if (root) apply(root);
  });
  // the buy box can set the fix method itself (deep links, its own rules) after it starts: follow it once more on load
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  window.addEventListener('pageshow', function (e) { if (e.persisted) all(); });
})();
